import React from 'react'
import styles from './ValuesContainer.module.scss'

const ValuesContainer = ({ valuesSection }) => {
  if (!valuesSection) return null

  return (
    <section className={styles.valuesContainer}>
      {valuesSection.map(
        value =>
          !!value.state && (
            <p key={value.content} className={styles[value.className]}>
              {value.content}{' '}
              {value.format ? (
                <span>R$ {value.state}</span>
              ) : (
                <span>{value.state}</span>
              )}
            </p>
          )
      )}
    </section>
  )
}

export default React.memo(ValuesContainer)
